import { Component, computed, inject, input } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import * as v from 'valibot';

import { vcVin } from '../../../utils/valibot/custom-types';

@Component({
  selector: 'cdf-vin',
  template: `
    @if (isValidVin()) {
      <span
        >{{ firstPart() }}<strong>{{ secondPart() }}</strong></span
      >
    } @else {
      <span>{{ vin() }}</span>
    }
  `,
})
export class VinComponent {
  private readonly logger = inject(NGXLogger);

  readonly vin = input.required<string>();

  readonly firstPart = computed(() => this.vin().slice(0, -7));
  readonly secondPart = computed(() => this.vin().slice(-7));
  readonly isValidVin = computed(() => {
    const result = v.safeParse(vcVin, this.vin());
    if (!result.success) {
      this.logger.debug('Got invalid VIN:', this.vin(), result.issues);
      return false;
    }
    return true;
  });
}
